var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2638_20664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1448 4H10C9.72386 4 9.5 4.22386 9.5 4.5C9.5 4.77614 9.72386 5 10 5H14C14.2761 5 14.5 4.77614 14.5 4.5V0.5C14.5 0.223858 14.2761 0 14 0C13.7239 0 13.5 0.223858 13.5 0.5V2.77469C12.1315 1.0394 10.1709 0 8 0C3.85786 0 0.5 3.35786 0.5 7.5C0.5 7.77614 0.723858 8 1 8C1.27614 8 1.5 7.77614 1.5 7.5C1.5 3.91014 4.41014 1 8 1C10.0843 1 11.9544 2.13064 13.1448 4Z",
    fill: "#2B5580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.2253V15.5C2.5 15.7761 2.27614 16 2 16C1.72386 16 1.5 15.7761 1.5 15.5V11.5C1.5 11.2239 1.72386 11 2 11H6C6.27614 11 6.5 11.2239 6.5 11.5C6.5 11.7761 6.27614 12 6 12H2.85523C4.04555 13.8694 5.91575 15 8 15C11.5899 15 14.5 12.0899 14.5 8.5C14.5 8.22386 14.7239 8 15 8C15.2761 8 15.5 8.22386 15.5 8.5C15.5 12.6421 12.1421 16 8 16C5.82908 16 3.86854 14.9606 2.5 13.2253Z",
    fill: "#2B5580"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2638_20664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.0c03c63343b32396e98b1f853102e6e2.svg";
export { ForwardRef as ReactComponent };